import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "plan-name-value" }
const _hoisted_2 = { class: "plan-name" }
const _hoisted_3 = { class: "middle-content" }
const _hoisted_4 = { class: "date-info" }
const _hoisted_5 = {
  key: 0,
  class: "supporting-text"
}
const _hoisted_6 = { class: "final-button" }
const _hoisted_7 = { class: "column-container d-flex w-100" }
const _hoisted_8 = { class: "container w-50" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "subcontainer" }
const _hoisted_11 = { class: "subcontainer" }
const _hoisted_12 = { class: "subcontainer" }
const _hoisted_13 = { class: "final-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    "can-minimize": true,
    ref: "requestRenewBasketPlanModal",
    "is-full-screen": true,
    "minimized-data": {
    type: $setup.MinimizedType.BASKET,
  }
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" SELECT DELIVERY OPTIONS "),
      _createElementVNode("section", {
        class: "data",
        style: _normalizeStyle({
      display: $setup.requestRenew.currentPage == $setup.RequestRenewPages.SELECT_DELIVERY_OPTIONS ? 'flex' : 'none',
    }),
        onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.closeAlteration()))
      }, [
        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "title" }, "Pedido de renovação de cesta", -1 /* HOISTED */)),
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "space-600" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString($setup.requestRenew.basketName), 1 /* TEXT */),
          _createVNode($setup["EditValueComponent"], {
            ref: "editValueComponent",
            suportingText: $setup.requestRenew.balanceError ?? '',
            "onUpdate:basketValue": _cache[0] || (_cache[0] = (v) => $setup.requestRenew.basketValue = v),
            "onReset:basketValue": _cache[1] || (_cache[1] = (_) => $setup.requestRenew.basketValue = $setup.basketValue ?? ''),
            basketValue: $setup.requestRenew.basketValue,
            onMouseenter: _cache[2] || (_cache[2] = ($event: any) => ($setup.isMouseOver = true)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => ($setup.isMouseOver = false))
          }, null, 8 /* PROPS */, ["suportingText", "basketValue"])
        ]),
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "space-400" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["StaffComponent"], {
            onChangePage: _cache[4] || (_cache[4] = ($event: any) => ($setup.goToScreen({ routeName: $setup.routes.usersList.name }))),
            title: "Quadro de colaboradores",
            "last-update": $setup.lastUpdateuser,
            state: `${($setup.requestRenew.usersCount ?? 0) > 0 ? 'default' : 'error'}`,
            "supporting-text": 'Não há colaboradores neste plano'
          }, null, 8 /* PROPS */, ["last-update", "state"]),
          _createVNode($setup["CommonToggle"], {
            label: "Confirmo que o quadro de colaboradores deste plano está atualizado",
            name: "autoGenDefaultBasket",
            supportingText: $setup.requestRenew.collaboratorsError,
            value: $setup.requestRenew.checkValue ?? false,
            onChange: _cache[5] || (_cache[5] = (_, value) => {$setup.requestRenew.checkValue = value; $setup.requestRenew.collaboratorsError = '' })
          }, null, 8 /* PROPS */, ["supportingText", "value"]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "space-800" }, null, -1 /* HOISTED */)),
          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "information-text" }, "Informações de entrega", -1 /* HOISTED */)),
          _createVNode($setup["DeliverySelector"], {
            ref: "deliverySelector",
            branchError: $setup.requestRenew.branchError,
            deliveryError: $setup.requestRenew.deliveryError,
            "branch-addresses": ($setup.createBasketPlanStore.branchAddresses as BranchAddresses),
            "onUpdate:deliveryType": _cache[6] || (_cache[6] = ($event: any) => ($setup.deliveryType = $event)),
            "onUpdate:pickupBranchId": _cache[7] || (_cache[7] = ($event: any) => ($setup.pickupBranchId = $event)),
            onCleanDeliveryError: _cache[8] || (_cache[8] = ($event: any) => ($setup.requestRenew.deliveryError = $event ?? '')),
            onCleanBranchError: _cache[9] || (_cache[9] = ($event: any) => ($setup.requestRenew.branchError = $event ?? '')),
            "z-index": $setup.zIndex ? $setup.zIndex + 1 : undefined
          }, null, 8 /* PROPS */, ["branchError", "deliveryError", "branch-addresses", "z-index"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode($setup["Datepicker"], {
              modelValue: $setup.requestRenew.deliveryDateUtc,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.requestRenew.deliveryDateUtc) = $event)),
              "enable-time-picker": false,
              "min-date": $setup.getMinDeliveryDate(),
              placeholder: "Data de entrega",
              teleport: true,
              locale: "pt-br",
              "month-name-format": "long",
              "day-names": $setup.FormatUtils.getDaysName(true),
              format: "dd/MM/yyyy",
              "select-text": "Selecionar",
              "cancel-text": "Cancelar"
            }, null, 8 /* PROPS */, ["modelValue", "min-date", "day-names"]),
            ($setup.requestRenew.dateError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.requestRenew.dateError), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createVNode($setup["TextAreaInput"], {
            class: "custom-datepicker",
            label: "Observações",
            state: "default",
            type: "text",
            "model-value": $setup.requestRenew.observation ?? '',
            "onUpdate:modelValue": _cache[11] || (_cache[11] = (v) => $setup.requestRenew.observation = v),
            onTapTrailing: _cache[12] || (_cache[12] = ($event: any) => ($setup.requestRenew.observation = ''))
          }, null, 8 /* PROPS */, ["model-value"])
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "space-600" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode($setup["CommonButton"], {
            onClick: $setup.clearModal,
            type: "outlined",
            text: "Cancelar",
            action: "secondary"
          }),
          _createVNode($setup["CommonButton"], {
            onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.goToPage($setup.RequestRenewPages.CONFIRMATION))),
            text: "Enviar pedido"
          })
        ])
      ], 4 /* STYLE */),
      _createCommentVNode(" CONFIRMATION "),
      _createElementVNode("section", {
        class: "data",
        style: _normalizeStyle({
      display: $setup.requestRenew.currentPage == $setup.RequestRenewPages.CONFIRMATION ? 'flex' : 'none',
    })
      }, [
        _cache[27] || (_cache[27] = _createElementVNode("p", { class: "title" }, "Pedido de renovação de cesta", -1 /* HOISTED */)),
        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "space-600" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            ($setup.basketPlan)
              ? (_openBlock(), _createBlock($setup["BasketPlanCard"], {
                  key: 0,
                  "hide-controls": true,
                  "basket-plan": ($setup.basketPlan as BasketPlan)
                }, null, 8 /* PROPS */, ["basket-plan"]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[23] || (_cache[23] = _createElementVNode("p", { class: "subtitle" }, "Total por colaborador", -1 /* HOISTED */)),
              _createVNode($setup["CurrencyValue"], {
                class: "margin-top-value",
                color: "pink",
                value: $setup.FormatUtils.parseFormattedNumber($setup.requestRenew.basketValue) ?? 0,
                fontReal: 21,
                fontSize: 21
              }, null, 8 /* PROPS */, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[24] || (_cache[24] = _createElementVNode("p", { class: "subtitle" }, "Colaboradores no plano", -1 /* HOISTED */)),
              _createVNode($setup["UsersCounter"], {
                count: $setup.requestRenew.usersCount ?? 0,
                "is-reverse": true,
                "has-size": 21,
                color: 'pink',
                "has-stroke": true
              }, null, 8 /* PROPS */, ["count"])
            ]),
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "separator w-75" }, null, -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_12, [
              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "subtitle" }, "Total", -1 /* HOISTED */)),
              _createVNode($setup["CurrencyValue"], {
                class: "margin-top-value",
                color: "pink",
                value: ($setup.FormatUtils.parseFormattedNumber($setup.requestRenew.basketValue) ?? 0) * ($setup.requestRenew.usersCount ?? 0),
                fontReal: 27,
                fontSize: 27
              }, null, 8 /* PROPS */, ["value"])
            ])
          ])
        ]),
        _cache[29] || (_cache[29] = _createElementVNode("div", { class: "space-600" }, null, -1 /* HOISTED */)),
        _createVNode($setup["PaymentMethodCard"], {
          "payment-methods": [{ type: $setup.PaymentMethodTypes.TICKET }],
          onChangeMethod: _cache[15] || (_cache[15] = (index) => console.log(index))
        }, null, 8 /* PROPS */, ["payment-methods"]),
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "space-600" }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_13, [
          _createVNode($setup["CommonButton"], {
            onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.goToPage($setup.RequestRenewPages.SELECT_DELIVERY_OPTIONS))),
            type: "outlined",
            text: "Voltar",
            action: "secondary"
          }),
          ($setup.requestRenew.usersCount)
            ? (_openBlock(), _createBlock($setup["CommonButton"], {
                key: 0,
                onClick: $setup.requestRenewBasketPlan,
                text: "Confirmar pedido de renovação"
              }))
            : _createCommentVNode("v-if", true)
        ])
      ], 4 /* STYLE */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["minimized-data"]))
}